import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import ImageConverterImageListScreen from "../image_converter/ImageConverterImageListScreen";

function ImageResizerMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Resize Images & Compress Images Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/image_resizer", title: "Reduce Image Size" },
    data2: { link: "/image_resizer", title: "Compress Image Under 300KB" },
    data3: { link: "/image_resizer", title: "Resize Image To Passport Size" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Online"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Resize images online easily. Change image dimensions, compress photos, and optimize pictures quickly with our fast and secure image resizer tool."
      ></meta>
      <meta
        name="keywords"
        content="image resizer, resize images online, resize image, photo resizer, image size reducer, image dimension changer, resize photos online, online image resizer, picture resizer, image editor online, compress and resize images, resize images for web, resize images for social media, image optimization tool, free image resizer, image compressor, compress image under 300KB, compress images under 200KB, compress images under 100KB, signature compressor, image resizer for govt form, passport resizer, stamp resizer, reduce image size,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <ImageConverterImageListScreen title={title} />
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{
              "image/*": [], // This MIME type accepts all image formats
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Image Resizer & Image Compressor website offers a fast, secure, and efficient way to resize and compress images without needing an internet connection. Built to work fully offline, this powerful tool processes images directly on your device, ensuring complete privacy and data security. Whether you need to reduce image file size, resize photos for websites, social media, or mobile apps, or optimize images for storage and sharing, this platform delivers high-quality results with minimal quality loss. The website supports popular formats such as JPG, PNG, WebP, and more, making it a reliable photo resizer and image compression tool for personal and professional use. Users can also choose online functionality when required, making it flexible enough to work as an image resizer online and image compressor online while still providing offline performance. With an intuitive interface and fast processing engine, users can resize images in bulk, compress large photos, and optimize visuals for SEO and faster page loading. Ideal for designers, developers, students, and content creators, this tool helps improve website performance and save storage space. If you are looking for a secure image resizer, a powerful image compressor, or an easy-to-use photo resizer that works offline, this website provides a complete solution for modern image optimization needs." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Resize",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Image Resizer"
            why_use={[
              {
                title: "Reduce Image File Size",
                description:
                  "Our image compressor reduces large image file sizes without major quality loss, making it easier to upload, share, and store images using an image compressor online or offline.",
              },
              {
                title: "Improve Website Speed and SEO",
                description:
                  "Using an image resizer and image compressor helps optimize images for faster page loading, improving user experience and SEO rankings.",
              },
              {
                title: "Resize Images for Multiple Platforms",
                description:
                  "Our image resizer online or offline allows users to resize photos for websites, social media, emails, and mobile apps. Our photo resizer ensures perfect image dimensions.",
              },
              {
                title: "Offline Processing for Privacy",
                description:
                  "This offline image resizer & image compressor processes images directly on your device, keeping files private without uploading them to an image compressor online service.",
              },
              {
                title: "Save Storage Space",
                description:
                  "Image compression reduces storage usage on devices and cloud platforms, making an image compressor ideal for managing large photo collections.",
              },
              {
                title: "Preserve Image Quality",
                description:
                  "Advanced image compression tools maintain visual clarity while reducing file size, ensuring professional-quality images after resizing.",
              },
              {
                title: "Faster Sharing and Uploading",
                description:
                  "Smaller image sizes created with an image resizer or image compressor online upload faster across websites, messaging apps, and email platforms.",
              },
              {
                title: "Supports Multiple Image Formats",
                description:
                  "Modern image resizer and image compressor tools support JPG, PNG, WebP, and other popular formats for flexible image optimization.",
              },
              {
                title: "Useful for Professionals and Individuals",
                description:
                  "Designers, developers, marketers, students, and everyday users rely on photo resizer and image compressor tools for efficient image management.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1614646280}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default ImageResizerMain;
